import { get_extension_packs, get_user_traffic_usage } from '../services/traffic.mjs';

const currency_formatters = {
  usd: new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }),
  eur: new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  }),
};
const pre_render_modal = (user, traffic_usage, options) => {
  let $querytraffic_modal = $(`
    <section id="traffic-extension-pack-modal" role="dialog" tabindex="-1" class="slds-modal slds-fade-in-open" aria-labelledby="modal-heading-traffic-extension-pack" aria-modal="true" aria-describedby="modal-content-traffic-extension-pack">
      <div class="slds-modal__container" style="max-width: 50rem;">
        <header class="slds-modal__header slds-p-around_small">
          <button class="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse" title="Fermer">
            <svg class="slds-button__icon slds-button__icon_large" aria-hidden="true">
              <use xlink:href="/styles/slds/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
            </svg>
            <span class="slds-assistive-text">Fermer</span>
          </button>
          <h2 id="modal-heading-traffic-extension-pack" class="slds-modal__title slds-text-title_caps">Pack d'extension du flux piéton</h2>
        </header>
        <div class="slds-modal__content slds-p-vertical_small slds-p-horizontal_medium" id="modal-content-traffic-extension-pack">
          <div id="traffic-credits-resume"></div>
          <div id="traffic-packs-container">
            <div style="height:5rem;">
              <div class="slds-align_absolute-center" style="height: 100%">
                <div role="status" class="slds-spinner slds-spinner_medium">
                  <span class="slds-assistive-text">Loading</span>
                  <div class="slds-spinner__dot-a"></div>
                  <div class="slds-spinner__dot-b"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="slds-backdrop slds-backdrop_open"></div>`);
  $querytraffic_modal.find('button.slds-modal__close').on('click', () => {
    $('#traffic-extension-pack-modal').remove();
    $('.slds-backdrop').remove();
  });
  $('#appContainer').append($querytraffic_modal);
  fetch_and_render_extension_packs(options);
};

const format_currency = (amount, currency) => {
  if (currency_formatters[currency]) {
    return currency_formatters[currency].format(amount);
  }
  return `${amount} ${currency}`;
};

const get_pack_card_header = (pack) => {
  return `
  <div class="extension-pack-header">
    <div>
      <div class="extension-pack-price slds-m-bottom_small">
        <span class="extension-pack-price_amount">${format_currency(pack.unit_amount / 100, pack.currency)}</span>        
      </div>
      <div class="slds-text-heading_small extension-pack-name slds-m-bottom_small">${pack.product.metadata.label}</div>
    </div>
  </div>`;
};

const get_pack_description = () => {
  return `
  <div class="extension-pack-features slds-hide">  
  </div>`;
};

const get_pack_icons = (pack) => {
  let icon = `/images/subscription/extensions_packs/pack_${pack.metadata.quantity}.png`;
  return icon;
};

const get_pack_card_body = (pack, options) => {
  //
  const c_footer = options.show_footer ? get_pack_card_footer(pack, options) : '';
  return `
  <div class="extension-pack-body">
    <div class="green-top-ellipse"></div>
    <div class="subscription_plan_image slds-m-bottom_x-large slds-align_absolute-center">
    <img src="${get_pack_icons(pack)}" />
    </div>
    ${get_pack_description(pack)}
    ${c_footer}
  </div>`;
};

const get_pack_card_footer = (pack, options) => {
  const disabled = !options.is_traffic_available ? 'disabled="disabled"' : '';
  const pack_id = !options.is_traffic_available ? '' : `data-packid="${pack.id}"`;
  return `
  <div class="extension-pack-footer">
    <button class="slds-button slds-button_brand ggo-cta"${pack_id} data-action="do-checkout" ${disabled}>Acheter</button>
  </div>`;
};

export const get_pack_card = (pack, options = {}) => {
  let content = `
    <div class="slds-box extension-pack-card" data-packid="${pack.id}">
      ${get_pack_card_header(pack)}
      ${get_pack_card_body(pack, options)}    
    </div>`;

  return content;
};

export const fetch_and_render_extension_packs = async (options = {}) => {
  const ctnr = options?.container ?? 'traffic-packs-container';
  const packs = await get_extension_packs();
  const traffic_usage = await get_user_traffic_usage();
  let formatted_since_date = '';
  if (traffic_usage.total > 0) {
    formatted_since_date = ` depuis le ${moment(traffic_usage.since_date).format('DD/MM/YYYY')}`;
  }
  let total_consumption = `
    <div class="slds-col slds-size_1-of-2">Consommation totale</div>
    <div class="slds-col slds-size_1-of-2">
      <div class="ggo-text-color_info">${traffic_usage.total} ${formatted_since_date}</div>
    </div>`;
  const is_traffic_available = options?.simulation_plan?.capabilities?.traffic?.available ?? false;
  const warning_message = !is_traffic_available
    ? `<div class="slds-m-around_x-small">Votre abonnement ne vous permet pas d'acheter ces packs. Veuillez passer à un abonnement Expert.
    <div class="slds-m-top_small slds-text-align_center slds-hide" >
        <a  class="slds-button slds-button_brand" href="/profile?section=subscription">Gérer votre abonnement</a>
      </div></div>`
    : '';
  const credits_consumption = is_traffic_available
    ? `<div class="slds-grid slds-grid_vertical-align-center slds-m-top_medium">
    <div class="slds-col slds-grow-none">
      <span class="slds-icon_container slds-icon-utility-form">
        <svg class="slds-icon slds-icon_large slds-icon-text-success" aria-hidden="true">
          <use xlink:href="/images/svg/symbols.svg#flow_icon"></use>
        </svg>
        <span class="slds-assistive-text">Description of icon when needed</span>
      </span>
    </div>
    <div class="slds-col slds-m-left_large" style="font-size: 1rem;">
      <div class="slds-grid slds-wrap slds-grid_align-spread">
        <div class="slds-col slds-size_1-of-2">Crédits de flux restants</div>
        <div class="slds-col slds-size_1-of-2">
          <div class="ggo-text-color_success">${traffic_usage.nb_left}</div>
        </div>
        ${total_consumption}
      </div>
    </div>
  </div>`
    : '';
  let $content = $(`
    <div class="slds-box slds-box_xx-small slds-hide" style="border-color: #2dc37d;">
      <div class="slds-p-around_x-small">
        <div class="slds-grid slds-grid_align-spread" style="font-weight: 700;">
          <div class="slds-col">
            <div class="slds-text-heading_small">Abonnement</div>
          </div>
          <div class="slds-col">
            <div class="slds-text-heading_small ggo-text-color_success">${options.simulation_plan.label}</div>
          </div>
        </div>
      </div>
    </div>
    ${warning_message}          
    ${credits_consumption}
    <div class="slds-grid slds-wrap slds-gutters">      
      ${packs
        .map((pack) => {
          return `
      <div class="slds-col slds-size_1-of-1 slds-small-size_1-of-1 slds-medium-size_1-of-3 slds-m-vertical_small">
        ${get_pack_card(pack, { show_footer: true, is_traffic_available })}
      </div>`;
        })
        .join('')}
    </div>`);
  $content.find('.extension-pack-footer .slds-button').on('click', (e) => {
    const priceId = $(e.currentTarget).data('packid');
    if (priceId) {
      console.log(`Let by the pack ${priceId}`);
      if (options.cb) {
        options.cb(priceId);
      }
    }
  });
  $(`#${ctnr}`).empty().append($content);
};

export const display_extension_packs_modal = (user, traffic_usage, options = {}) => {
  //
  pre_render_modal(user, traffic_usage, options);
};

export const buy_extension_pack = (priceId, return_url, cancel_return_url) => {
  let cancelUrl = '';
  if (cancel_return_url) {
    cancelUrl = `<input type="hidden" id="basicPrice" name="cancelReturnUrl" value="${cancel_return_url}"/>`;
  }
  const submit_form = $(`
  <form action="/rest/stripe/buy-extension-pack" method="POST">
    <input type="hidden" id="basicPrice" name="priceId" value="${priceId}"/>
    <input type="hidden" id="basicPrice" name="returnUrl" value="${return_url}"/>
    ${cancelUrl}
  </form>`);
  $('body').append(submit_form);
  submit_form.submit();
};
